module.exports = __webpack_public_path__ + "img/geofisica_3-4.b0d757dc.jpg";